import axios from 'axios';
import store from '../store/index';

const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND,
});

if (store.state.auth.accessToken) {
  http.defaults.headers.Authorization = `Bearer ${store.state.auth.accessToken}`;
}

export default http;
